/**
 * Created by Olga Eremina on 13.10.2026
 */

const RemovedUnit = function (unit) {
    this.info = unit.getInfo();
    this.x = unit.x;
    this.y = unit.y;
    this.price = Unit.CalcSellPrice(unit);
};

RemovedUnit.prototype.isSold = function () {
    return this.price > 0;
};

RemovedUnit.prototype.getStars = function () {
    return cleverapps.meta.getSelectedLocation().stars;
};

RemovedUnit.prototype.findSlot = function () {
    const field = Merge2.current.field;
    return field.isEmpty(this.x, this.y) ? cc.p(this.x, this.y) : field.findEmptySlot(this.x, this.y);
};

RemovedUnit.prototype.canUndo = function (view) {
    if (this.isSold() && !this.getStars().canTakeStars(this.price)) {
        return false;
    }

    if (!this.findSlot()) {
        if (view) {
            Merge2.current.showNoSpaceHint(view);
        }
        return false;
    }

    return true;
};

RemovedUnit.prototype.undo = function () {
    const slot = this.findSlot();

    if (this.isSold()) {
        this.getStars().takeStars(this.price);
    }

    const field = Merge2.current.field;
    const unit = new Unit(this.info);

    unit.setPosition(slot.x, slot.y);
    field.onAddUnit(slot.x, slot.y, unit);
    field.onUnitAvailable(unit);
    unit.onAdd();

    return unit;
};
